import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '@app/core/services/custom-services/localstorage.service';

@Injectable({ providedIn: 'root' })
export class TrackHeadersInterceptor implements HttpInterceptor {

  constructor(private localStorageService: LocalStorageService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    let tenantId = this.localStorageService.getItem(LocalStorageService.userTennat);
    
    if (tenantId) {
      const clonedReq = req.clone({
        setHeaders: { 'X-TenantId': tenantId }
      });
      return next.handle(clonedReq);
    }

    return next.handle(req);
  }
}
